export default "__VITE_ASSET__DCV2KlsK__"